import React from "react";
import { Box } from "@mui/material";
import "./MapLoadScreen.css"; // Ensure you have this CSS file for styles

const MapLoadScreen = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)", // Center the circle
        width: "200px",
        height: "200px",
      }}
    >
      <svg
        viewBox="0 0 32 32"
        style={{
          width: "100%",
          height: "100%",
          animation: "spin 1s linear infinite",
        }}
      >
        <circle cx="16" cy="16" r="15" fill="transparent" stroke="#f3f3f3" />

        <circle
          cx="16"
          cy="16"
          r="15"
          fill="transparent"
          stroke="blue"
          strokeDasharray="75 25" // 75% orange, 25% transparent
          strokeLinecap="round" // Makes the ends of the stroke round
        />
      </svg>
    </Box>
  );
};

export default MapLoadScreen;
